import { render } from "preact";
import { App } from "./ui/App";
import "./styles/calculator.css";

declare global {
  interface Window {
    tcaSsCalc?: {
      webhookUrl?: string;
      newsletterUrl?: string;
      affiliateUrl?: string;
      blogIndexUrl?: string;
      binderUrl?: string;
    };
  }
}

function mount() {
  const root = document.getElementById("tca-ss-calc-root");
  if (!root) return;
  render(<App />, root);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount, { once: true });
} else {
  mount();
}
